exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v3-modal-mask{position:fixed;top:0;bottom:0;left:0;right:0;display:flex;justify-content:center;background-color:rgba(0,0,0,.45);overflow:hidden;z-index:12}.v3-modal{height:-moz-fit-content;height:fit-content;margin-top:75pt;background-color:#fff;border-radius:3px;box-shadow:0 0 10px 0 rgba(0,0,0,.16)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/componentsv3/Modal/style.css
 ** module id = 934
 ** module chunks = 0
 **/